import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import PorcentagemComissao from "../PorcentagemComissao";
import ListaComissoes from "../ListaComissoes";

interface GerenciarComissoesProps {
  token: string;
  role: "MASTER" | "PARTNER" | "ANALYST";
}

const GerenciarComissoes: React.FC<GerenciarComissoesProps> = ({
  token,
  role,
}) => {
  return (
    <Box sx={{ padding: 2 }}>
      <PorcentagemComissao token={token} role={role} />
      <ListaComissoes token={token} role={role} />
    </Box>
  );
};

export default GerenciarComissoes;
